import { render } from "./siteSet.vue?vue&type=template&id=b8925ca2"
import script from "./siteSet.vue?vue&type=script&lang=js"
export * from "./siteSet.vue?vue&type=script&lang=js"

import "./siteSet.vue?vue&type=style&index=0&id=b8925ca2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__